import React, { Component } from 'react';
import AdhExcelUpload from './adhExcelUpload';

var config=require('./config');
var guiUtils=require('./ApsHtmlGuiUtils');




class ImportAdhXlsx extends Component {
	constructor(props){
		super(props);
		this.state={userRank:''};
		this.getUserRights=this.getUserRights.bind(this);
		
	}
	
	
	getUserRights()
	{
		let str=config.sqlServerAddress()+'/gRaw/getUserRights/'
		+"'"+sessionStorage.getItem("u")+"','"+sessionStorage.getItem("p")+"'";
		fetch(str).then(response=>{
			if(response.status>=400){
				throw new Error("Bad resp");
			}
			return response.json();
		}).then(parsed=>{
			this.setState({userRank:parsed[0].rank});
		}).catch(err=>{console.log('caught',err);
		});
	}
	
	componentDidMount()
	{
	    this.getUserRights();
	}
	
	
	
	
	render()
	{
		let rank=this.state.userRank;
		
		if(rank=="0")
		{
			return (<div> Rang = {rank}</div>);
		}
		else if(rank=="2")
		{
			return (<div id='importAdhTable'><div class='text'>Import Fichier CSV Adhérents
			</div><br/>
			<AdhExcelUpload />
			</div>);
			
		}
			else return (<div>Attendre</div>);	
		
		//ReactDom.render(<PartFinderButton />,document.getElementById('_partFinderButton'));
	}
}

export default ImportAdhXlsx;